<template>
  <v-app>
    <v-main :style="loader ? 'pointer-events:none;' : ''">
      <the-loader v-if="loader" />
      <the-header 
        v-if="showHeader"
        :logged-user="user"
        :url="image"
      />
      <div class="app-content col-md-12 d-flex justify-content-center align-items-center flex-column px-0" :class="{'app-content--auth': !showHeader}">
        <div v-if="showHeader && $route.meta.title" class="page-heading col-md-11">
          <span v-for="(part, i) in titleTrail" :key="i" class="page-heading__trail">{{part}}<i class="mdi mdi-chevron-right"></i></span>
          <h1 class="page-heading__title">{{titleCurrent}}</h1>
        </div>
        <transition name="page-fade" mode="out-in">
          <router-view />
        </transition>
      </div>
      <the-footer 
        v-if="showHeader"
      />
    </v-main>
  </v-app>
</template>

<script>
import {mapState, mapActions} from "vuex";
import TheLoader from "@/components/layout/TheLoader";
export default {
  name: 'App',
  components:{
    TheHeader: () => import("@/components/layout/TheHeader"),
    TheFooter: () => import("@/components/layout/TheFooter"),
    TheLoader
  },
  computed: {
    ...mapState("login", ["user", "image"]),
    ...mapState("loader", ["loader"]),
    ...mapState("pages", ["previousPage"]),
    // "Controle Leiteiro > Serviços": trilha discreta + nome da tela em destaque
    titleParts() {
      return String(this.$route.meta.title || "").split(">").map(e => e.trim()).filter(Boolean);
    },
    titleTrail() {
      return this.titleParts.slice(0, -1);
    },
    titleCurrent() {
      return this.titleParts[this.titleParts.length - 1];
    },
    showHeader() {
      if(this.$route.name !== "Login") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions("login", ["actionCheckLogin"]),
    ...mapActions("pages", ["actionGetPreviousPage"]),
    saveRouter() {
      this.actionGetPreviousPage();
      window.onload = () => {
        if(this.showHeader && this.previousPage) {
          this.$router.push({name:this.previousPage.name, params:{...this.previousPage.params}});
        }
      }
    }
  },
  created() {
    this.actionCheckLogin();
    this.saveRouter();
  }
};
</script>

<style>
  @import url("./assets/css/sidebar.css");
  /* Cores e medidas compartilhadas (revisão visual 10/2026) */
  :root {
    --medium-blue:#150b32;
    --light-grey:rgba(0, 0, 0, 0.1);
    --backround-page:#f4f5f8;
    --green:#3d9a50;
    --light-green:#70f2d9;
    --jersey-yellow:#dfa006;
    --jersey-yellow-dark:#b98300;
    --jersey-yellow-soft:#fdf5e1;
    --ink:#1f2433;
    --muted:#5f6673;
    --line:#e6e8ee;
    --radius:12px;
    --shadow-sm:0 1px 2px rgba(16, 24, 40, .06), 0 1px 3px rgba(16, 24, 40, .08);
    --shadow-md:0 4px 16px rgba(16, 24, 40, .08);
    --header-height:68px;
  }
  /* resets de css + estilização compartilhada */
  * {
    box-sizing: border-box; 
    padding: 0;
    margin: 0;
  }
  .v-application {
    color: var(--ink) !important;
  }
  .v-application--wrap {
    background-color: var(--backround-page);
  }
  /* conteúdo abaixo do cabeçalho fixo */
  /* embaixo, espaço para os botões flutuantes (+ / exportar) não cobrirem o fim da página */
  .app-content {
    padding-top: calc(var(--header-height) + 20px) !important;
    padding-bottom: 72px !important;
  }
  .app-content--auth {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  /* título da tela: trilha + nome */
  .page-heading {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 2px 4px;
    padding: 4px 0 0 !important;
  }
  .page-heading__trail {
    color: var(--muted);
    font-size: .85rem;
    display: inline-flex;
    align-items: center;
  }
  .page-heading__trail i {
    font-size: 1rem;
    opacity: .6;
  }
  .page-heading__title {
    color: var(--ink);
    font-size: 1.35rem !important;
    font-weight: 700;
    margin: 0;
    letter-spacing: -.01em;
  }
  /* cartão de conteúdo de cada tela */
  .router-view-background,
  .router-view-report-background {
    background-color: white;
    padding: 28px 32px !important;
    border-radius: var(--radius);
    border: 1px solid var(--line);
    box-shadow: var(--shadow-sm);
    margin-top: 14px;
    margin-bottom: 28px;
    font-size: 0.9rem;
    min-height: 100%;
  }
  /* relatórios usam col-md-12: mesma largura do título (col-md-11) */
  .router-view-report-background {
    max-width: calc(100% / 12 * 11);
  }
  /* nada dentro do cartão passa da largura dele (as tabelas largas rolam por dentro) */
  .router-view-background > *,
  .router-view-report-background > * {
    max-width: 100%;
    min-width: 0;
  }
  /* transição suave entre telas */
  .page-fade-enter-active,
  .page-fade-leave-active {
    transition: opacity .18s ease, transform .18s ease;
  }
  .page-fade-enter,
  .page-fade-leave-to {
    opacity: 0;
    transform: translateY(6px);
  }
  h1,h2,h3,h4,h5 {
    font-size: 0.9rem;
  }
  .v-application a {
    color: var(--ink) !important;
  }
  .dropdown-item.active, .dropdown-item:active {
    background-color: transparent !important;
  }
  /* botões (Vuetify): cantos, peso e sem caixa-alta forçada */
  .v-application .v-btn:not(.v-btn--round):not(.v-btn--fab):not(.v-btn--rounded) {
    border-radius: 8px;
  }
  .v-application .v-picker .v-btn {
    font-weight: 500;
  }
  .v-application .v-btn {
    text-transform: none;
    letter-spacing: .01em;
    font-weight: 600;
  }
  .v-application .v-btn.success {
    background-color: var(--green) !important;
  }
  /* "Voltar" dos painéis e modais: contorno neutro (antes vermelho, como se fosse excluir) */
  .v-application .v-btn.btn-back {
    color: var(--ink) !important;
    border-color: #d5d9e2 !important;
    background-color: white !important;
  }
  /* botão de ações das tabelas (Menu / Editar) */
  .menu-table {
    background: var(--jersey-yellow) !important;
    color: white;
    border-radius: 8px;
    box-shadow: var(--shadow-sm);
    transition: background-color .15s ease, box-shadow .15s ease;
  }
  .menu-table:hover {
    background: var(--jersey-yellow-dark) !important;
    box-shadow: var(--shadow-md);
  }
  .dropdown-menu {
    border: 1px solid var(--line) !important;
    border-radius: 10px !important;
    box-shadow: var(--shadow-md) !important;
    padding: 6px 0 !important;
  }
  .dropdown-menu .dropdown-item {
    padding: 8px 18px;
    font-size: .9rem;
  }
  .dropdown-menu .dropdown-item:hover {
    background-color: var(--jersey-yellow-soft) !important;
  }
  .wrapper {
    min-height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .v-application ul {
    padding-left: 0 !important;
  }
  li.b-drop-options a {
    display: flex;
    align-items: center;
  }
  li.b-drop-options.close a {
    color: #d33 !important;
  }
  .btn {
    color: white !important;
  }
  .top-divisor {
    border-top:1px solid var(--line);
  }
  .buttonAdd {
    background-color:var(--jersey-yellow) !important;
    color: white !important;
  }
  .single-icon {
    font-size: 2rem;
    cursor:pointer;
  }
  .single-icon.app-blue {
    color: var(--medium-blue);
  }
  .single-icon.app-green {
    color: var(--green);
  }
  .col-md-12, .col-md-10, .col-md-11, .col-md-5 {
    flex: 0 0 auto !important;
  }
  /* classe de infinite-scroll */
  .infinite-box {
    max-height: 600px;
    overflow-y: scroll;
  }
  .v-autocomplete .v-input__control .v-text-field__details {
    display: none !important;
  }
  .resize-autocomplete {
    max-height: 200px;
    overflow-y: scroll;
  }
  /* Bootstrap 5 põe float/margem/fonte no <legend>; o Vuetify usa o legend para recortar a borda dos
     campos outlined onde fica o rótulo flutuante — com o float a borda não é recortada e o rótulo
     fica em cima da linha (acontecia em todo o sistema) */
  .v-application .v-text-field--outlined legend {
    float: none;
    margin-bottom: 0;
    font-size: inherit;
  }
  /* painel de formulário/filtros do topo das telas: campos em linha + ação no fim */
  .form-panel {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 14px 16px;
    padding: 18px 20px !important;
    margin-bottom: 20px;
    background: #fafbfd;
    border: 1px solid var(--line);
    border-radius: 12px;
    animation: panel-in .35s ease-out both;
  }
  .form-panel__title {
    width: 100%;
    margin: 0 !important;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: .78rem !important;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: var(--muted);
  }
  .form-panel__title i {
    font-size: 1.05rem;
    color: var(--jersey-yellow-dark);
  }
  .form-panel .form-panel__field {
    flex: 1 1 210px;
    min-width: 190px;
    max-width: 340px;
  }
  .form-panel .form-panel__field--wide {
    flex: 2 1 320px;
    max-width: 520px;
  }
  .form-panel__actions:empty {
    display: none;
  }
  .form-panel__toggles {
    display: flex;
    align-items: center;
    gap: 22px;
  }
  .form-panel__actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  /* sem a reserva de espaço das mensagens quando não há erro (os erros continuam aparecendo) */
  .form-panel .v-input__slot {
    margin-bottom: 0 !important;
  }
  .form-panel .v-text-field__details,
  .form-panel .v-messages {
    min-height: 0 !important;
  }
  .form-panel .v-text-field__details {
    margin-bottom: 0 !important;
  }
  .form-panel .v-input--switch,
  .form-panel .v-input--selection-controls {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  /* título de seção dentro do cartão (ex.: "305 dias" no Extrato) */
  .section-title {
    font-size: .78rem !important;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: var(--muted);
    margin: 14px 0 8px;
  }
  /* grade de informações (rótulo pequeno + valor), ex.: cabeçalho do serviço */
  .info-grid {
    width: 100%;
    display: grid;
    grid-auto-flow: dense;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 12px;
    padding: 0 !important;
    margin-bottom: 18px;
    animation: panel-in .35s ease-out both;
  }
  .info-item {
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 12px 14px;
    background: #fafbfd;
    border: 1px solid var(--line);
    border-radius: 10px;
  }
  .info-item--wide {
    grid-column: span 2;
  }
  .info-item > span {
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: var(--muted);
  }
  .info-item > b {
    font-size: .98rem;
    color: var(--ink);
  }
  /* campo editável dentro da grade (ex.: Data do Controle na pesagem) */
  .info-item--field {
    padding: 8px 10px;
    justify-content: center;
  }
  .info-item--field .v-text-field__details {
    display: none;
  }
  /* blocos das ordenhas (esgotamento, 1ª, 2ª, 3ª) */
  .milking-row {
    gap: 14px;
    border-top: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .milking-row > div {
    flex: 1 1 0 !important;
    max-width: none !important;
    padding: 14px 16px !important;
    background: #fafbfd;
    border: 1px solid var(--line);
    border-radius: 12px;
  }
  .milking-row h5 {
    font-size: .8rem !important;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: var(--jersey-yellow-dark);
    margin-bottom: 10px;
  }
  .milking-row .v-text-field__details,
  .milking-row .v-messages {
    min-height: 0 !important;
  }
  .milking-row .v-text-field__details {
    margin-bottom: 0 !important;
  }
  .milking-row p {
    font-size: .78rem;
    color: var(--muted);
    margin-bottom: 4px !important;
  }
  .milking-row h6 {
    font-size: .85rem;
    color: var(--ink);
    margin-bottom: 4px;
  }
  /* cartões de números (totais dos relatórios) */
  .stat-cards {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 14px;
    margin-bottom: 20px;
  }
  .stat-card {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 16px 18px 16px 22px;
    background: white;
    border: 1px solid var(--line);
    border-radius: 12px;
    box-shadow: var(--shadow-sm);
    animation: pop-in .4s ease-out both;
  }
  .stat-card::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: var(--jersey-yellow);
  }
  .stat-card + .stat-card {
    animation-delay: .06s;
  }
  .stat-card__label {
    font-size: .75rem;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: var(--muted);
  }
  .stat-card__value {
    font-size: 1.9rem;
    font-weight: 800;
    line-height: 1.15;
    color: var(--ink);
  }
  .stat-card__hint {
    font-size: .78rem;
    color: var(--muted);
  }
  @keyframes panel-in {
    from { opacity: 0; transform: translateY(-6px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes pop-in {
    from { opacity: 0; transform: scale(.97) translateY(6px); }
    to { opacity: 1; transform: scale(1) translateY(0); }
  }
  /* botões reagem ao passar o mouse */
  .v-application .v-btn {
    transition: transform .12s ease, box-shadow .15s ease, background-color .15s ease;
  }
  .v-application .v-btn:not(.v-btn--disabled):not(.v-btn--text):not(.v-btn--icon):hover {
    transform: translateY(-1px);
  }
  /* telas menores: grades em uma coluna, ordenhas quebram linha, cartões com menos respiro */
  @media (max-width: 992px) {
    .milking-row {
      flex-wrap: wrap;
    }
    .milking-row > div {
      flex: 1 1 200px !important;
    }
  }
  @media (max-width: 600px) {
    .router-view-background,
    .router-view-report-background {
      padding: 18px 14px !important;
      max-width: 100%;
    }
    .info-item--wide {
      grid-column: auto;
    }
    .form-panel {
      padding: 14px !important;
    }
    .form-panel .form-panel__field,
    .form-panel .form-panel__field--wide {
      max-width: none;
      flex-basis: 100%;
    }
    .form-panel__actions {
      margin-left: 0;
    }
    .page-heading__title {
      font-size: 1.15rem !important;
    }
  }
  /* celular: respiro lateral do conteúdo */
  @media (max-width: 767px) {
    .app-content {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
    .app-content > .page-heading,
    .app-content > .col-md-11,
    .app-content > .col-md-12 {
      width: 100% !important;
    }
  }
  /* tabela dentro de modal ou painel lateral: títulos das colunas presos no topo do próprio modal (TheTable) */
  .v-dialog,
  .sidebar-panel {
    --table-sticky-top: 0px;
  }
  /* modais (Vuetify) */
  .v-dialog {
    border-radius: 16px !important;
  }
  .v-dialog > .v-card {
    border-radius: 16px !important;
  }
  .v-dialog .v-card__title {
    font-weight: 700;
  }
  .v-menu__content {
    border-radius: 10px !important;
    box-shadow: var(--shadow-md) !important;
  }
  /* paginação (Vuetify) */
  .v-pagination__item,
  .v-pagination__navigation {
    box-shadow: none !important;
    border: 1px solid var(--line);
    border-radius: 8px !important;
  }
  /* página ativa com a mesma cor em todas as telas (algumas passavam azul-marinho, outras o padrão) */
  .v-pagination__item--active {
    background-color: var(--jersey-yellow-dark) !important;
    border-color: var(--jersey-yellow-dark) !important;
    color: white !important;
  }
  /* botão de ações das linhas com o tamanho do texto da tabela */
  .menu-table.m-2 {
    margin: 2px !important;
  }
  .menu-table .btn {
    font-size: .85rem;
    padding: 4px 12px;
  }
  /* calendário (FullCalendar): sem o sublinhado dos links do Bootstrap; visão ativa destacada */
  .fc a {
    text-decoration: none !important;
    color: inherit !important;
  }
  .fc .fc-button-primary.fc-button-active,
  .fc .fc-button-primary:not(:disabled):active {
    background-color: var(--jersey-yellow-dark) !important;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, .18) !important;
  }
  .fc .fc-toolbar-title {
    font-size: 1.3rem;
    font-weight: 700;
  }
</style>
